import React, { useState, useEffect } from 'react';
import { useSiteSettings } from '../components/SiteSettingsProvider';

const TermsConditions = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { siteName } = useSiteSettings();

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  return (
    <div className="terms-wrapper">
      {/* Hero Section */}
      <section className="terms-hero">
        <div className="hero-bg-elements">
          <div className="glow glow-1"></div>
          <div className="glow glow-2"></div>
        </div>
        <div className={`hero-content ${isVisible ? 'visible' : ''}`}>
          <div className="eyebrow">
            <span className="eyebrow-dot"></span>
            <span>Legal</span>
          </div>
          <h1 className="hero-title">
            <span className="title-serif">Website Terms</span>
            <span className="title-accent">of Use</span>
          </h1>
          <p className="hero-subtitle">
            Last updated: April 2024
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="content-section">
        <div className="container">
          <div className="content-grid">
            {/* Sidebar Navigation */}
            <aside className="sidebar">
              <nav className="sidebar-nav">
                <a href="#introduction" className="nav-item active">Introduction</a>
                <a href="#general" className="nav-item">General</a>
                <a href="#disclaimer" className="nav-item">Website Disclaimer</a>
                <a href="#prohibitions" className="nav-item">Prohibitions</a>
                <a href="#intellectual" className="nav-item">Intellectual Property</a>
                <a href="#terms-sale" className="nav-item">Terms of Sale</a>
                <a href="#contract" className="nav-item">Our Contract</a>
                <a href="#pricing" className="nav-item">Pricing & Availability</a>
                <a href="#payment" className="nav-item">Payment</a>
                <a href="#customer" className="nav-item">Customer</a>
                <a href="#termination" className="nav-item">Termination</a>
                <a href="#limitation" className="nav-item">Limitation of Liability</a>
                <a href="#governing" className="nav-item">Governing Law</a>
              </nav>
            </aside>

            {/* Main Content */}
            <main className="main-content">
              <div className="content-block">
                <p className="intro-text">
                  This document is an electronic record in terms of Information Technology Act, 2000 and rules there under as applicable and the amended provisions pertaining to electronic records in various statutes as amended by the Information Technology Act, 2000. This electronic record is generated by a computer system and does not require any physical or digital signatures.
                </p>
                <p>
                  This document is published in accordance with the provisions of Rule 3 (1) of the Information Technology (Intermediaries guidelines) Rules, 2011 that require publishing the rules and regulations, Privacy Policy and Terms of Use for access or usage of our website: www.blisswell.in.
                </p>
                <p>
                  The domain name www.blisswell.in or (hereinafter referred to as "Website") is owned by M/s {siteName || 'Blisswell'}, which is a registered company, having its head office at Nashik, Maharashtra, India (hereinafter referred to as "{siteName || 'Blisswell'}").
                </p>
              </div>

              <div id="general" className="content-block">
                <h2>In General</h2>
                <p>
                  {siteName || 'Blisswell'} owns and operates the website with its full ownership & control. This document governs your relationship with {siteName || 'Blisswell'} as a Customer. Access to and use of this website and the products and services available through this website (collectively, the "Services") are subject to the following terms, conditions, and notices ("Website Terms of Use").
                </p>
                <p>
                  By using the Services, you are agreeing to all of the website terms of use, as may be updated by us from time to time. You should check this page regularly to take notice of any changes we may have made to the website terms of use.
                </p>
                <p>
                  Access to this website is permitted on a temporary basis, and we reserve the right to withdraw or amend the Services without notice. We will not be liable if for any reason this website is unavailable at any time or for any period. From time to time, we may restrict access to some parts or this entire website.
                </p>
              </div>

              <div id="disclaimer" className="content-block">
                <h2>Website Disclaimer</h2>
                <p>
                  The contents of this website are only for information purpose. Users are advised to rely on information posted herein for any purpose only after verification and confirmation of the same from authentic and authoritative sources.
                </p>
                <p>
                  Neither {siteName || 'Blisswell'} nor the website developer is responsible for any consequences that may arise out of using such information without verification / confirmation. There may be time gap in internet / online posting / transmission of information and availability of such information at browsers' end.
                </p>
                <p>
                  Exact status may be confirmed from source www.blisswell.in. We are running this website, to promote our business.
                </p>
                <p className="highlight-box">
                  The Payment Gateway, which we mentioned in this website, is our official account, the money collected from this website on behalf of {siteName || 'Blisswell'} i.e. M/s {siteName || 'Blisswell'} on the sale of products exclusively marketed by M/s {siteName || 'Blisswell'}.
                </p>
              </div>

              <div id="prohibitions" className="content-block">
                <h2>Prohibitions</h2>
                <p>
                  The services available on this website are for customers, who are interested and have requested to become a Customer of the {siteName || 'Blisswell'}. Once you register as a user, you will permit us to fill {siteName || 'Blisswell'} registration form and to mention your name where ever your signature is required.
                </p>
                <p>You must not misuse this website: www.blisswell.in. You will not:</p>
                <ul>
                  <li>Commit or encourage a criminal offense</li>
                  <li>Transmit or distribute a virus, trojan, worm, logic bomb or any other material which is malicious, technologically harmful, in breach of confidence or in any way offensive or obscene</li>
                  <li>Hack into any aspect of the service</li>
                  <li>Corrupt data</li>
                  <li>Cause annoyance to other users</li>
                  <li>Infringe upon the rights of any other person's proprietary rights</li>
                  <li>Send any unsolicited advertising or promotional material, commonly referred to as "spam"</li>
                  <li>Attempt to affect the performance or functionality of any computer facilities of or accessed through this website</li>
                </ul>
                <p className="highlight-box warning">
                  <strong>Warning:</strong> Breaching this provision would constitute a criminal offense and {siteName || 'Blisswell'} will report any such breach to the relevant law enforcement authorities and disclose your identity to them. We will not be liable for any loss or damage caused by a distributed denial-of-service attack, viruses or other technologically harmful material that may infect your computer equipment, computer programs, data, or other proprietary material due to your use of this website or to your downloading of any material posted on it, or on any website linked to it.
                </p>
              </div>

              <div id="intellectual" className="content-block">
                <h2>Intellectual Property, Software and Content</h2>
                <p>
                  The intellectual property rights in all software and content (including photographic images) made available to you on or through this website remains the property of {siteName || 'Blisswell'} or its licensors and are protected by copyright laws and treaties around the world. All such rights are reserved by {siteName || 'Blisswell'} and its licensors.
                </p>
                <p>You may store, print, and display the content supplied solely for your own personal use. You are not permitted to:</p>
                <ul>
                  <li>Publish, manipulate, distribute, or otherwise reproduce, in any format, any of the content or copies of the content supplied to you or which appears on this website</li>
                  <li>Use any such content in connection with any business or commercial enterprise</li>
                </ul>
              </div>

              <div id="terms-sale" className="content-block">
                <h2>Terms of Sale</h2>
                <p>
                  By placing an order, you are offering to purchase a product on and subject to the following terms and conditions. All orders are subject to availability and confirmation of the order price.
                </p>
                <p>
                  Dispatch times may vary according to availability and subject to any delays resulting from postal delays or force majeure for which we will not be responsible.
                </p>
                <p>
                  In order to contract with {siteName || 'Blisswell'} you must be over <strong>18 years of age</strong>. {siteName || 'Blisswell'} retains the right to refuse any request made by you.
                </p>
                <p>
                  If your order is accepted, we will inform you by email. When placing an order, you undertake that all details you provide to us are true and accurate, that you are an authorized user of the credit or debit card used to place your order and that there are sufficient funds to cover the cost of the goods. All prices advertised are subject to such changes.
                </p>
              </div>

              <div id="contract" className="content-block">
                <h2>Our Contract</h2>
                <p>
                  When you place an order, you will receive an acknowledgement e-mail confirming receipt of your order: this email will only be an acknowledgement and will not constitute acceptance of your order.
                </p>
                <p>
                  A contract between us will not be formed until we send you confirmation by e-mail that the goods which you ordered have been dispatched to you. Only those goods listed in the confirmation e-mail sent at the time of dispatch will be included in the contract formed.
                </p>
              </div>

              <div id="pricing" className="content-block">
                <h2>Pricing and Availability</h2>
                <p>
                  Whilst we try and ensure that all details, descriptions, and prices which appear on this website are accurate, errors may occur.
                </p>
                <p>
                  If we discover an error in the price of any goods which you have ordered we will inform you of this as soon as possible and give you the option of reconfirming your order at the correct price or cancelling it.
                </p>
                <p>
                  If we are unable to contact you, we will treat the order as cancelled. If you cancel and you have already paid for the goods, you will receive a full refund.
                </p>
                <p>
                  Delivery costs will be charged in addition; such additional charges are clearly displayed where applicable and included in the 'Total Cost.'
                </p>
              </div>

              <div id="payment" className="content-block">
                <h2>Payment</h2>
                <p>
                  There are various methods of payment used by {siteName || 'Blisswell'}. These methods of payment can be online either through wallets / debit / credit card or account transfer.
                </p>
                <p>
                  Upon receiving your order, we carry out a standard authorization check on your payment card to ensure there are sufficient funds to fulfill the transaction. Your card will be debited upon authorization being received.
                </p>
                <p>
                  The amount received upon the debiting of your card shall be treated as a deposit against the value of the goods you wish to purchase. Once the goods have been dispatched and you have been sent a confirmation email the amount paid as a deposit shall be used as consideration for the value of goods you have purchased as listed in the confirmation email.
                </p>
              </div>

              <div id="customer" className="content-block">
                <h2>Customer</h2>
                <p>
                  Upon receiving your request to become Customer with the Company, that he / she has read, understood, and accepted all the terms and conditions and {siteName || 'Blisswell'} through its separate Marketing Plan to provide incentives and offers to its customers. The detailed terms and conditions of such Marketing Plan shall be made available to you by {siteName || 'Blisswell'} separately.
                </p>
                <p>
                  The Customer shall be required to sign these Terms of Use physically at the time of joining as the Customer of the Company. You acknowledge and confirm that the Company shall be entitled to use your signature wherever required in the course of your business relationship with the Company.
                </p>
              </div>

              <div id="termination" className="content-block">
                <h2>Termination</h2>
                <p>
                  We have the right to terminate your access to the website and the services offered on it if you do not comply with these Terms of Use or any other policy of {siteName || 'Blisswell'}. Such termination shall be without prejudice to any other rights or remedies of {siteName || 'Blisswell'}.
                </p>
                <p>
                  On termination of your registration, your right to use the website shall immediately cease. We may also suspend or terminate your access to the website at any time, without notice, for any reason, including but not limited to breach of these Terms of Use.
                </p>
              </div>

              <div id="limitation" className="content-block">
                <h2>Limitation of Liability</h2>
                <p>
                  To the maximum extent permitted by law, {siteName || 'Blisswell'} shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, or other intangible losses resulting from:
                </p>
                <ul>
                  <li>Your use or inability to use our services</li>
                  <li>Any errors or omissions in our content</li>
                  <li>Unauthorized access to your account</li>
                  <li>Any interruption or cessation of our services</li>
                  <li>Any bugs, viruses, or harmful code transmitted through our platform</li>
                </ul>
                <p>
                  Our total liability for any claim arising from your use of our services shall not exceed the amount you have paid to us in the 12 months preceding the claim.
                </p>
              </div>

              <div id="governing" className="content-block">
                <h2>Governing Law and Dispute Resolution</h2>
                <p>
                  These Terms and Conditions are governed by the laws of India. Any disputes arising from these terms or your use of our services shall be subject to the exclusive jurisdiction of the courts in Nashik, Maharashtra.
                </p>
                <h3>Dispute Resolution Process</h3>
                <ol>
                  <li>First, contact our customer support to attempt resolution</li>
                  <li>If unresolved, either party may initiate mediation</li>
                  <li>If mediation fails, disputes may be submitted to arbitration</li>
                  <li>Arbitration shall be conducted under the Arbitration and Conciliation Act, 1996</li>
                </ol>
                <p>
                  Any dispute(s) between Customer or its nominee(s) and {siteName || 'Blisswell'}, arising from this Policy, shall be referred to the sole arbitrator (appointed by {siteName || 'Blisswell'}) and same shall be adjudicated by such Arbitrator as per provisions of Arbitration Conciliation Act, 1996.
                </p>
                <p>
                  However, all proceedings shall come within the jurisdiction of <strong>District Courts in Nasik (Maharashtra, India)</strong> only and such arbitration proceedings shall be held in district courts of Nasik (Maharashtra, India) only.
                </p>
              </div>

              <div className="content-block">
                <h2>Contact Us</h2>
                <p>If you have any questions about these Terms and Conditions, please contact us:</p>
                <div className="contact-info">
                  <div className="contact-item">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                      <polyline points="22,6 12,13 2,6"/>
                    </svg>
                    <span>servicesblisswell@gmail.com</span>
                  </div>
                  <div className="contact-item">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10"/>
                      <line x1="2" y1="12" x2="22" y2="12"/>
                      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
                    </svg>
                    <span>Website: www.blisswell.in</span>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </section>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&display=swap');

        .terms-wrapper {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          background: #fafafa;
          color: #0a0a0a;
          line-height: 1.6;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1.5rem;
        }

        /* Hero */
        .terms-hero {
          position: relative;
          min-height: 40vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);
          overflow: hidden;
          padding: 4rem 1.5rem;
        }

        .hero-bg-elements {
          position: absolute;
          inset: 0;
          pointer-events: none;
        }

        .glow {
          position: absolute;
          border-radius: 50%;
          filter: blur(100px);
        }

        .glow-1 {
          width: 400px;
          height: 400px;
          background: rgba(7, 60, 57, 0.08);
          top: -50px;
          right: -50px;
        }

        .glow-2 {
          width: 300px;
          height: 300px;
          background: rgba(5, 150, 105, 0.06);
          bottom: -50px;
          left: -50px;
        }

        .hero-content {
          position: relative;
          text-align: center;
          opacity: 0;
          transform: translateY(30px);
          transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .hero-content.visible {
          opacity: 1;
          transform: translateY(0);
        }

        .eyebrow {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.5rem 1rem;
          background: rgba(7, 60, 57, 0.08);
          border-radius: 100px;
          margin-bottom: 1.5rem;
          font-size: 0.8125rem;
          font-weight: 500;
          color: #073C39;
        }

        .eyebrow-dot {
          width: 6px;
          height: 6px;
          background: #073C39;
          border-radius: 50%;
        }

        .hero-title {
          font-family: 'Playfair Display', Georgia, serif;
          margin: 0 0 1rem 0;
          line-height: 1.1;
        }

        .title-serif {
          display: block;
          font-size: clamp(2.5rem, 5vw, 3.5rem);
          font-weight: 500;
          color: #0a0a0a;
        }

        .title-accent {
          display: block;
          font-size: clamp(2.5rem, 5vw, 3.5rem);
          font-weight: 500;
          background: linear-gradient(135deg, #073C39, #5D8172);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .hero-subtitle {
          font-size: 1rem;
          color: #525252;
        }

        /* Content Section */
        .content-section {
          padding: 4rem 0;
        }

        .content-grid {
          display: grid;
          grid-template-columns: 280px 1fr;
          gap: 4rem;
        }

        /* Sidebar */
        .sidebar {
          position: sticky;
          top: 100px;
          height: fit-content;
        }

        .sidebar-nav {
          display: flex;
          flex-direction: column;
          gap: 0.25rem;
        }

        .nav-item {
          padding: 0.75rem 1rem;
          font-size: 0.875rem;
          color: #525252;
          text-decoration: none;
          border-radius: 8px;
          transition: all 0.2s ease;
        }

        .nav-item:hover,
        .nav-item.active {
          background: #fff;
          color: #0a0a0a;
          font-weight: 500;
        }

        .nav-item.active {
          box-shadow: 0 1px 3px rgba(0,0,0,0.05);
        }

        /* Main Content */
        .main-content {
          max-width: 720px;
        }

        .content-block {
          margin-bottom: 3rem;
          padding-bottom: 3rem;
          border-bottom: 1px solid #e5e5e5;
        }

        .content-block:last-child {
          border-bottom: none;
          margin-bottom: 0;
          padding-bottom: 0;
        }

        .intro-text {
          font-size: 1.125rem;
          color: #525252;
          line-height: 1.8;
        }

        .content-block h2 {
          font-size: 1.5rem;
          font-weight: 600;
          color: #0a0a0a;
          margin: 0 0 1.5rem 0;
        }

        .content-block h3 {
          font-size: 1.125rem;
          font-weight: 600;
          color: #0a0a0a;
          margin: 1.5rem 0 0.75rem 0;
        }

        .content-block p {
          font-size: 1rem;
          color: #525252;
          line-height: 1.7;
          margin: 0 0 1rem 0;
        }

        .content-block ul,
        .content-block ol {
          margin: 0 0 1rem 0;
          padding-left: 1.5rem;
        }

        .content-block li {
          font-size: 1rem;
          color: #525252;
          line-height: 1.7;
          margin-bottom: 0.5rem;
        }

        .content-block li strong {
          color: #0a0a0a;
        }

        .highlight-box {
          padding: 1rem 1.25rem;
          border-radius: 8px;
          margin: 1rem 0;
        }

        .highlight-box.warning {
          background: #fef3c7;
          border-left: 4px solid #f59e0b;
          color: #92400e !important;
        }

        .highlight-box {
          background: #E3EDE4;
          border-left: 4px solid #073C39;
          color: #073C39 !important;
        }

        /* Contact Info */
        .contact-info {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .contact-item {
          display: flex;
          align-items: flex-start;
          gap: 1rem;
          padding: 1rem;
          background: #fff;
          border-radius: 12px;
          border: 1px solid #e5e5e5;
        }

        .contact-item svg {
          flex-shrink: 0;
          color: #073C39;
          margin-top: 0.125rem;
        }

        .contact-item span {
          font-size: 0.9375rem;
          color: #525252;
        }

        /* Responsive */
        @media (max-width: 1024px) {
          .content-grid {
            grid-template-columns: 1fr;
          }

          .sidebar {
            position: relative;
            top: auto;
          }

          .sidebar-nav {
            flex-direction: row;
            flex-wrap: wrap;
            gap: 0.5rem;
          }

          .nav-item {
            padding: 0.5rem 1rem;
            font-size: 0.8125rem;
          }
        }

        @media (max-width: 768px) {
          .terms-hero {
            min-height: auto;
            padding: 3rem 1.5rem;
          }

          .title-serif,
          .title-accent {
            font-size: 2rem;
          }
        }
      `}</style>
    </div>
  );
};

export default TermsConditions;